export default {
  'language': 'Idioma',
  'listening': 'Escucha',
  'reading': 'Lectura',
  'speaking': 'Conversación',
  'writing': 'Escritura',
  'representativeSkill': 'Habilidad(es) representativa'
}